{
  "messages": {
    "rescheduledOnce": "Reprogrammé une fois",
    "rescheduledTwice": "Reprogrammé deux fois",
    "rescheduledCountTimes": "Reprogrammé {count} fois"
  }
}
